export default __webpack_public_path__ + "arrow.92e764f3.svg";